export default __webpack_public_path__ + "static/screenshot-262cd65997d5a443576582ac9f8851fb.png";